import { render } from "./AddressError.vue?vue&type=template&id=70fefcf6&ts=true"
import script from "./AddressError.vue?vue&type=script&lang=ts"
export * from "./AddressError.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__